var React = require('react');

function OneHourDrive (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.18,1A4.77,4.77,0,0,0,4.42,5.75c0,2.63,4.76,8.31,4.76,8.31s4.76-5.68,4.76-8.31A4.77,4.77,0,0,0,9.18,1Zm0,6.69A1.93,1.93,0,1,1,11.1,5.75,1.92,1.92,0,0,1,9.18,7.67Z","key":0}),React.createElement("ellipse",{"cx":"9.16","cy":"14.48","rx":"6.82","ry":"1.91","key":1})]);
}

OneHourDrive.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = OneHourDrive;

OneHourDrive.default = OneHourDrive;
